import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Funnel_Display\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-funnel\",\"display\":\"swap\"}],\"variableName\":\"funnel\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Geologica\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-geologica\",\"display\":\"swap\"}],\"variableName\":\"geologica\"}");
;
import(/* webpackMode: "eager", webpackExports: ["LayoutContent"] */ "/app/src/app/layout-content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SidebarProvider"] */ "/app/src/components/layout/Sidebar.tsx");
